import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {Observable, tap} from 'rxjs';
import { User } from '../types/user.model';
import { environment } from '../../../environments/environment';
import {SessionService} from "../../state/session.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CreateAdminUserRequest} from '../types/create-admin-user.request';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  private session = inject(SessionService);
  private snack = inject(MatSnackBar);

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(environment.API_URL + '/api/user/all');
  }

  createAdminUser(request: CreateAdminUserRequest): Observable<User> {
    return this.http.post<User>(environment.API_URL + '/api/admin/user', request)
      .pipe(tap(() => this.snack.open('User created', 'OK', {duration: 5000})));
  }

  updateLanguage(language: string) {
    return this.http.patch<User>(environment.API_URL + '/api/user/language', { language }).subscribe();
  }

  update(user: User): Observable<User> {
    return this.http.patch<User>(environment.API_URL + '/api/user/admin/' + user.uuid, user).pipe(
      tap(() => this.snack.open('User updated', 'OK', { duration: 5000 })));
  }

  fetchUser() {
    return this.http.get<User>(environment.API_URL + '/api/user')
      .pipe(tap((user) => this.session.user = user));
  }
}
